<template>
    <v-layout>
        <v-main>
            <v-container>
                <v-card class="text-h6" style="padding: 1em !important">
                    Hier stellen wir euch relevante Dokumente zur Verfügung.<br />
                </v-card>
                <v-card class="text-h6" style="margin: 2em !important; padding: 2em !important">
Hier möchten wir euch auf das Seuchenrecht der EU hinweisen:<br />
<u><a href="https://eur-lex.europa.eu/legal-content/DE/TXT/PDF/?uri=CELEX:32016R0429">EU VO 429/2016 (seit 01.04.21)</a></u><br />
Uns liegt es am Herzen, dass man die Gesundheit der Fellpopos im Blick hat und mitbekommt, wenn im Gebiet Krankheiten und Seuchen ausbrechen und wie man damit umgehen soll.
                </v-card>
            </v-container>
        </v-main>
    </v-layout>
</template>
